// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeHeader--bg {
  display: flex;
  justify-content: center;
  background: linear-gradient(180deg, #000 0%, #00AA74 35.89%);
}

.logo {
  text-align: center;
  margin-top: -29rem;
  position: relative;
  z-index: 2;
}

.HomeHeader--content {
  position: relative;
  z-index: 1;
  margin-top: -9.5rem;
  padding-top: 15rem;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background-color: white;
}

@media screen and (max-width: 360px) {
  .responsive--logo {
    margin-top: -34rem;
  }
}
.Navbar__standard__banner {
  background-color: #ffefc7;
  color: #902424;
  padding: 0.4rem 0.6rem;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.8rem;
  border-bottom: 0.1rem solid #f2f2f2;
  z-index: 10;
  display: flex;
}
.Navbar__standard__banner a {
  color: #902424;
  text-decoration: underline;
  font-weight: 600;
}
.Navbar__standard__banner a:hover {
  text-decoration: none;
}

.Navbar__banner-close {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #902424;
  padding: 0;
  margin-left: 10px;
}

.Navbar__banner-message {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/Layout/HomeHeader/style.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,uBAAA;EACA,4DAAA;AADJ;;AAIA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AADJ;;AAIA;EACI,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,uBAAA;AADJ;;AAKA;EACI;IACI,kBAAA;EAFN;AACF;AAMI;EACI,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mCAAA;EACA,WAAA;EACA,aAAA;AAJR;AAKQ;EACI,cAAA;EACA,0BAAA;EACA,gBAAA;AAHZ;AAKY;EACI,qBAAA;AAHhB;;AASA;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;AANJ;;AASE;EACM,kBAAA;AANR","sourcesContent":["@import '../../../Styles/sass/variables';\n\n.HomeHeader--bg {\n    display: flex;\n    justify-content: center;\n    background: linear-gradient(180deg, #000 0%, #00AA74 35.89%);\n}\n\n.logo {\n    text-align: center;\n    margin-top: -29rem;\n    position: relative;\n    z-index: 2;\n}\n\n.HomeHeader--content {\n    position: relative;\n    z-index: 1;\n    margin-top: -9.5rem;\n    padding-top: 15rem;\n    border-top-left-radius: 24px;\n    border-top-right-radius: 24px;\n    background-color: white;\n    // height: 70vh;\n}\n\n@media screen and (max-width: 360px) {\n    .responsive--logo {\n        margin-top: -34rem;\n    }\n}\n\n.Navbar__standard {\n    &__banner {\n        background-color: #ffefc7; // Light yellow background\n        color: #902424; // Black text color\n        padding: 0.4rem 0.6rem;\n        font-size: 1.4rem;\n        font-weight: 500;\n        line-height: 1.8rem;\n        border-bottom: 0.1rem solid #f2f2f2;\n        z-index: 10;\n        display: flex;\n        a {\n            color: #902424; // Link color\n            text-decoration: underline;\n            font-weight: 600;\n\n            &:hover {\n                text-decoration: none;\n            }\n        }\n    }\n \n}\n.Navbar__banner-close {\n    background: none;\n    border: none;\n    font-size: 2rem;\n    cursor: pointer;\n    color: #902424;\n    padding: 0;\n    margin-left: 10px;\n  }\n\n  .Navbar__banner-message{\n        text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
